import { useEventbus } from 'hooks/useEventbus';

export const useFireEvent = () => {
  const { fireEvent } = useEventbus(undefined, []);

  return { fireEvent };
};
